import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { Link, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

interface BackButtonProps {
  to: string;
  label: string;
}

export default function BackButton({ to, label }: BackButtonProps) {
  return (
    <Link
      component={RouterLink}
      to={to}
      sx={{ display: "flex", alignItems: "center", gap: 0.5 }}
      underline="hover"
    >
      <ArrowBackIosIcon fontSize="large" />
      <Typography variant="h2">{label}</Typography>
    </Link>
  );
}
